import React from 'react';

// CSS for the table
const tableStyle = {
  width: '80%',
  margin: '30px auto',
  borderCollapse: 'collapse',
  backgroundColor: '#f8f9fa',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  border: '1px solid #ddd',  // Add border around the entire table
};

const headerStyle = {
  backgroundColor: '#007bff',
  color: 'white',
  textAlign: 'left',
  padding: '12px',
  fontSize: '16px',
  fontWeight: 'bold',
  borderBottom: '2px solid #ddd', // Add bottom border to the header row
};

const rowStyle = {
  borderBottom: '1px solid #ddd',  // Add border between rows
};

const cellStyle = {
  padding: '12px',
  textAlign: 'left',
  fontSize: '14px',
  color: '#333',
  border: '1px solid #ddd',  // Add border to each cell
};

const evenRowStyle = {
  backgroundColor: '#e9ecef',
};

const oddRowStyle = {
  backgroundColor: '#ffffff',
};

const SpecificationsTable = () => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      <h2 style={{ textAlign: 'center', color: '#007bff', fontWeight: 'bold' }}>
        Product Specifications
      </h2>
      <table style={tableStyle}>
        <thead>
          <tr style={headerStyle}>
            <th style={cellStyle}>Specification</th>
            <th style={cellStyle}>Details</th>
          </tr>
        </thead>
        <tbody>
          {/* Physical Specifications Rows */}
          <tr style={evenRowStyle}>
            <td style={cellStyle}>Dimensions</td>
            <td style={cellStyle}>260mm×325mm×325mm</td>
          </tr>
          <tr style={oddRowStyle}>
            <td style={cellStyle}>Light Weight</td>
            <td style={cellStyle}>6Kg</td>
          </tr>
          <tr style={evenRowStyle}>
            <td style={cellStyle}>Display Type</td>
            <td style={cellStyle}>LCD Display</td>
          </tr>
          <tr style={oddRowStyle}>
            <td style={cellStyle}>Display Size</td>
            <td style={cellStyle}>3.5 inches</td>
          </tr>
          <tr style={evenRowStyle}>
            <td style={cellStyle}>Language</td>
            <td style={cellStyle}>English</td>
          </tr>

          {/* Power Specifications Rows */}
          <tr style={oddRowStyle}>
            <td style={cellStyle}>Input Voltage</td>
            <td style={cellStyle}>A.C. 220V or 110V</td>
          </tr>
          <tr style={evenRowStyle}>
            <td style={cellStyle}>Frequency</td>
            <td style={cellStyle}>50Hz/60Hz</td>
          </tr>
          <tr style={oddRowStyle}>
            <td style={cellStyle}>Maximum Power</td>
            <td style={cellStyle}>1200VA</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SpecificationsTable;
